<div class="modal-content">
  <div class="d-flex text-black modal-header pl-4 pr-4 mt-2">
    <h5 class="font-18 mt-1">Application Type Notice</h5>
    <button type="button" class=" btn p-0" aria-label="Close" (click)="modalClose()">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="sub-heading mt-4">
      <p class="para-1 mb-2">{{ noticeHeading }}</p>
      <p class="para-1 mb-2">{{ noticeContent }}</p>
    </div>
  </div>
  <div class="btn-container ">
    <button type="button" class="btn btn-outline-secondary w-100" (click)="modalClose()">Edit Education Selection</button>
    <button type="button" class="btn btn-primary w-100" (click)="proceedWithApplication()" *ngIf="showProceedButton">{{ buttonText }}</button>
  </div>
</div>